'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _withSpacing = require('../withSpacing');

var _withSpacing2 = _interopRequireDefault(_withSpacing);

var _Input = require('../Input');

var _Input2 = _interopRequireDefault(_Input);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = {
  'screen-small': '(max-width: 539px)',
  'screen-gt-small': '(min-width: 540px)',
  'screen-medium': '(max-width: 959px)',
  'screen-gt-medium': '(min-width: 960px)',
  'screen-large': '(max-width: 1247px)',
  'screen-gt-large': '(min-width: 1248px)',
  'screen-x-large': '(max-width: 1919px)',
  'screen-gt-x-large': '(min-width: 1920px)',
  'container': 'tcl__InputWithIcon-dc3edaf1',
  'icon': 'tcl__InputWithIcon-7ea37bb9',
  'input': 'tcl__InputWithIcon-22647c62'
};


var InputWithIcon = function InputWithIcon(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? 'text' : _ref$type,
      icon = _ref.icon,
      className = _ref.className,
      isValid = _ref.isValid,
      props = _objectWithoutProperties(_ref, ['type', 'icon', 'className', 'isValid']);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(styles.container, className) },
    _react2.default.createElement(_Icon2.default, { name: icon, color: 'light-grey', className: styles.icon, size: 18 }),
    _react2.default.createElement(_Input2.default, _extends({}, props, { type: type, className: styles.input, isValid: isValid }))
  );
};

InputWithIcon.displayName = 'InputWithIcon';
InputWithIcon.propTypes = _extends({}, _withSpacing.propTypes, {
  className: _propTypes2.default.string,
  icon: _propTypes2.default.string.isRequired,
  isValid: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['email', 'number', 'password', 'search', 'tel', 'text', 'url']).isRequired
});

InputWithIcon.defaultProps = {
  className: '',
  isValid: true
};

exports.default = (0, _withSpacing2.default)(InputWithIcon);